export const visitorSiteConfig = {
  siteId: 'vuza',
  siteName: 'VUZA Group',
  excludedPathPrefixes: ['/user_count'],
} as const;

